import {ActionIcon, Menu} from '@mantine/core';
import {IconDownload, IconMarkdown, IconPrinter} from '@tabler/icons-react';
import type {FC} from 'react';
import type {UseChatTranscriptExportResult} from 'src/pages/Modules/Assistant/shared/export/useChatTranscriptExport';

export type ChatExportMenuProps = UseChatTranscriptExportResult;

export const ChatExportMenu: FC<ChatExportMenuProps> = ({
  canExport,
  downloadMarkdown,
  print,
}) => (
  <Menu shadow="md" width={220} position="bottom-end">
    <Menu.Target>
      <ActionIcon
        variant="subtle"
        color="gray"
        aria-label="Export conversation"
        disabled={!canExport}>
        <IconDownload size={18} />
      </ActionIcon>
    </Menu.Target>
    <Menu.Dropdown>
      <Menu.Item leftSection={<IconMarkdown size={16} />} onClick={downloadMarkdown}>
        Download Markdown
      </Menu.Item>
      <Menu.Item leftSection={<IconPrinter size={16} />} onClick={print}>
        Print / Save as PDF
      </Menu.Item>
    </Menu.Dropdown>
  </Menu>
);
